import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import {
  DocumentDetailsInterface,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import WebService from "../../../../Services/WebService";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import ErrorComponent from "../../../Common/ErrorComponent";
import HelperService from "../../../../Services/HelperService";
import UploadDocument from "../../UploadDocument/UploadDocuments";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import {
  getDocumentIfAvailable,
  hasAllMandatoryDocs,
} from "../../../../Services/CommonFunction";
import {
  ACCOUNT_TYPE_API,
  DOCUMENT_TYPE,
  excludedDocKeys,
} from "../../../../assets/constants/constants";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import SuccessPopup from "../../SuccessPopup";
import { Button } from "react-bootstrap";


interface PropsData {
  impIds: RegistrationIds;
  handleNext: any;
  from?: any;
}

const proofOfBusinessTypes = [
  {
    label: "Business Registration",
    value: "BUSINESS_REGISTRATION_CERTIFICATE",
  },
  {
    label: "Tax Identification",
    value: "TAX_IDENTIFICATION_NUMBER_CERTIFICATE",
  },
  { label: "Business License", value: "BUSINESS_LICENSE" },
  { label: "Articles of Incorporation", value: "ARTICLES_OF_INCORPORATION" },
  {
    label: "Certificate of Good Standing",
    value: "CERTIFICATE_OF_GOOD_STANDING",
  },
  { label: "Operating Agreement (LLC)", value: "OPERATING_AGREEMENT_FOR_LLC" },
  { label: "Partnership Agreement", value: "PARTNERSHIP_AGREEMENT" },
  { label: "Bank Account Statement", value: "BANK_ACCOUNT_STATEMENT" },
  {
    label: "Utility Bill (Business Name)",
    value: "UTILITY_BILL_IN_BUSINESS_NAME",
  },
  {
    label: "VAT/GST Registration Certificate",
    value: "VAT_OR_GST_REGISTRATION_CERTIFICATE",
  },
  { label: "Trade License", value: "TRADE_LICENSE" },
  { label: "Insurance Certificate", value: "INSURANCE_CERTIFICATE" },
  {
    label: "Client Contracts or Invoices",
    value: "CONTRACTS_OR_INVOICES_FROM_CLIENTS",
  },
];

const DocumentDetailsWantToGrow = ({ impIds, handleNext, from }: PropsData) => {
  const [documents, setDocuments] = useState<DocumentDetailsInterface[]>([]);
  const [fileLoaders, setFileLoaders] = useState<{ [key: string]: boolean }>(
    {},
  );
  const [selectedTypeOfProof, setSelectedTypeOfProof] = useState([
    { value: "", label: "Select" },
  ]);
  const [apiCallTriggered, setAPICallTriggered] = useState(false);

  const [pitchDeck, setPitchDeck] = useState(0);
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (impIds && impIds?.business_uuid) {
      handleGetDocumentDetails();
    }
  }, []);
  useEffect(() => {
    if (from === "FROM_PROFILE_ANALYSIS") {
      setChecked1(true);
      setChecked2(true);
    }
  }, [from]);
  const handleGetDocumentDetails = () => {
    setLoader(true);
    WebService.getAPI({
      action: `get-business/want-to-sell/${impIds?.business_uuid}`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        if (res?.status === true) {
          setDocuments(res?.info?.documents);
          if (res?.info?.documents?.length > 0) {
            res?.info?.documents.forEach((docu: DocumentDetailsInterface) => {
              if (docu?.type === "PITCH_DECK") {
                setPitchDeck(1);
              }
              if (!excludedDocKeys.includes(docu?.type)) {
                setSelectedTypeOfProof([
                  {
                    value: docu?.type,
                    label: HelperService.removeUnderScore(docu.type),
                  },
                ]);
              }
            });
          }
        }
      })
      .catch((error: any) => {
        return false;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const uploadFile = (event: any) => {
    const selectedFiles = event.target.files;
    let maxSizeFile = false;
    Array.from(selectedFiles).map((file: any) => {
      if (file.size > 10 * 1024 * 1024) {
        maxSizeFile = true;
        toast.error("Maximum file size 10 mb");
        return;
      }
    });
    if (maxSizeFile) {
      return;
    }

    if (selectedFiles && selectedFiles.length > 0) {
      handleUploadFile(selectedFiles[0], event.target.name);

      event.target.value = null;
    }
  };

  async function handleUploadFile(file: any, type: string) {
    if (type === "") {
      toast.error("Please select type of document first");
      return;
    }
    let body = {
      type: type,
      is_pitch_deck: pitchDeck,
    };
    setFileLoaders((prev) => ({ ...prev, [type]: true }));
    let accountType = impIds.account_type as keyof typeof ACCOUNT_TYPE_API;
    await WebService.uploadAPI({
      action: `upload-document/want_to_grow/${impIds?.business_uuid}`,
      body: body,
      _file: file,
      key: "file",
    })
      .then((res: any) => {
        if (res?.status) {
          if (res?.access_token) {
            localStorage.setItem("access_token", res?.access_token);
          }
          handleGetDocumentDetails();
          toast.success(res?.message);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setFileLoaders((prev) => ({ ...prev, [type]: false }));
      });
  }
  const getDocumentTitle = (title: string) => {
    if (documents && documents?.length > 0) {
      let docTitle: DocumentDetailsInterface = {
        file_name: "",
        title: "",
        type: "",
        file_title: "",
      };
      documents.forEach((docu: DocumentDetailsInterface) => {
        if (docu?.type === title) {
          docTitle = docu;
        }
      });
      return docTitle;
    } else return null;
  };

  const handleContinue = (flag: boolean) => {
    if (
      from !== "REVIEW" &&
      // proofOfBusinessUploaded ||
      // !hasAllMandatoryDocs(documents, MandatoryDoc) ||
      (!checked1 || !checked2)
    ) {
      setErrorFlag(true);
      return;
    }
    if (!from) {
      if (flag) WebService.addLoader("skip_basic_details");
      else WebService.addLoader("doc_continue");
      setAPICallTriggered(true);

      return WebService.postAPI({
        action: `complete-registration/${impIds?.uuid}`,
        body: null,
        isShowError: false,
      })
        .then((res: any) => {
          console.log(res);

          if (res?.status) {
            setShow(true);

            localStorage.setItem("access_token", res?.access_token);
            handleNext();
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error: any) => {
          toast.error(error?.response?.data?.message);

          return error;
        })
        .finally(() => {
          if (flag) WebService.removeLoader("skip_basic_details");
          else WebService.removeLoader("doc_continue");
          setAPICallTriggered(false);
        });
    } else {
      handleNext(true);
    }
  };
  return (<>
    <div className="login-form w-100 px-0 position-relative">
      {loader ? <CompoLoader /> : null}

      <div className="custom-title my-auto font-bold mb-2">Documents</div>
      <p className="font-14 mb-1">Please upload all the documents below.</p>
      <CommonScrollbar height={"65vh"}>
        <RequiredLabel isRequired={false}>Business Photo</RequiredLabel>
        <UploadDocument
          type={"BUSINESS_PHOTO"}
          fileLoaders={fileLoaders}
          document={getDocumentIfAvailable(
            DOCUMENT_TYPE.BUSINESS_PHOTO,
            documents,
          )}
          accept="image/*"
          uploadFile={uploadFile}
          infoCall={() => handleGetDocumentDetails()}
        />
        {/* <ErrorComponent
          title="Please upload business photo"
          flag={errorFlag}
          isArray={false}
          data={getDocumentTitle("BUSINESS_PHOTO")?.title ?? ""}
        /> */}
        <div className="mb-2">
          <RequiredLabel isRequired={false}>Proof of Business</RequiredLabel>

          <Select
            dropdownHeight="200px"
            className="multi-select"
            options={proofOfBusinessTypes}
            onChange={(values: any) => {
              if (values.length > 0) {
                setSelectedTypeOfProof(values);
              }
            }}
            labelField="label"
            valueField="value"
            placeholder="Select"
            name="proof"
            values={
              from === "REVIEW"
                ? [{ value: "", label: "Select" }]
                : selectedTypeOfProof
            }
          />
        </div>
        <UploadDocument
          type={selectedTypeOfProof[0]?.value}
          fileLoaders={fileLoaders}
          uploadFile={uploadFile}
          documentList={documents}
          accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
          infoCall={() => handleGetDocumentDetails()}
        />
        {/* {errorFlag && !proofOfBusinessUploaded && (
          <ErrorComponent
            title="Please upload business proof"
            flag={errorFlag}
            isArray={false}
            data={""}
          />
        )} */}
        <div>
          <RequiredLabel isRequired={false}>
            Product Service Catalog
          </RequiredLabel>

          <UploadDocument
            type={DOCUMENT_TYPE?.PRODUCT_SERVICE_CATALOG}
            fileLoaders={fileLoaders}
            uploadFile={uploadFile}
            document={getDocumentIfAvailable(
              DOCUMENT_TYPE.PRODUCT_SERVICE_CATALOG,
              documents,
            )}
            infoCall={() => handleGetDocumentDetails()}
            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
          />
        </div>
        <div>
          <RequiredLabel isRequired={false}>
            Company Profile Brochure
          </RequiredLabel>

          <UploadDocument
            type={DOCUMENT_TYPE?.COMPANY_PROFILE_BROUCHER}
            fileLoaders={fileLoaders}
            uploadFile={uploadFile}
            document={getDocumentIfAvailable(
              DOCUMENT_TYPE.COMPANY_PROFILE_BROUCHER,
              documents,
            )}
            infoCall={() => handleGetDocumentDetails()}
            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
          />
        </div>
        <div>
          <RequiredLabel isRequired={false}>
            Certificates / Compliance Documents
          </RequiredLabel>

          <UploadDocument
            type={DOCUMENT_TYPE?.CERTIFICATE_COMPLIANCE_DOCUMENTS}
            fileLoaders={fileLoaders}
            uploadFile={uploadFile}
            document={getDocumentIfAvailable(
              DOCUMENT_TYPE.CERTIFICATE_COMPLIANCE_DOCUMENTS,
              documents,
            )}
            infoCall={() => handleGetDocumentDetails()}
            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
          />
        </div>
        {from && from === "REVIEW" ? null : (
          <div>
            <div className="form-check mb-0">
              <input
                className={
                  errorFlag && !checked1
                    ? "custom-checkbox form-check-input"
                    : "form-check-input"
                }
                type="checkbox"
                value=""
                id="flexCheckDefault"
                checked={checked1}
                onChange={() => setChecked1(!checked1)}
              />
              <label
                className="form-check-label pb-0"
                htmlFor="flexCheckDefault"
              >
                <span className="checkbox-title">
                  {" "}
                  I have read and agree to the{" "}
                  <a
                    href="https://theprimeshark.com/terms-of-use/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    terms and conditions
                  </a>
                </span>
              </label>
            </div>
          </div>
        )}
        {from && from === "REVIEW" ? null : (
          <div>
            <div className="form-check mb-4">
              <input
                className={
                  errorFlag && !checked2
                    ? "custom-checkbox form-check-input"
                    : "form-check-input"
                }
                type="checkbox"
                value=""
                id="flexCheckDefault1"
                checked={checked2}
                onChange={() => setChecked2(!checked2)}
              />
              <label
                className="form-check-label pb-0"
                htmlFor="flexCheckDefault1"
              >
                <span className="checkbox-title">
                  {" "}
                  I give my consent to the processing of my personal data,
                  including for AI matchmaking, in line with the{" "}
                  <a
                    href="https://theprimeshark.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Privacy Policy
                  </a>.
                </span>
              </label>
            </div>
          </div>
        )}
        <div className="mb-2 d-flex gap-2">
          <Button
            disabled={apiCallTriggered}
            className={
              from !== "PROFILE_ANALYSIS"
                ? "btn btn-primary w-100"
                : "btn btn-primary w-50"
            }
            type="button"
            onClick={() => {
              handleContinue(false);
            }}
          >
            {from && from === "REVIEW" ? "Save" : "Continue"}
          </Button>
          {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
            <Button
              disabled={apiCallTriggered}
              className="btn btn-secondary w-50"
              type="button"
              id="skip_basic_details"
              onClick={() => {
                handleContinue(true);
              }}
            >
              Skip
            </Button>
          )}
        </div>{" "}
      </CommonScrollbar>
      {show && (
        <SuccessPopup
          show={show}
          msg="Global connect profile registered successfully!"
          id="global_connect_id"
        />
      )}
    </div>

  </>
  );
};
export default DocumentDetailsWantToGrow;
